import React, { useContext, useEffect, useState } from 'react'
import AdminSidebar from './AdminSidebar'
import AdminHeader from './AdminHeader'
import { AuthContext } from '../../../context/Authcontext';

const FancyHistory = () => {
     const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
     const [permit, setPermit]= useState([]);
     const {getRoles}= useContext(AuthContext);
     const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    
      // Toggle sidebar visibility
      const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
      };

      const fetchRoles= async ()=> {
        const auth= localStorage.getItem('admin');
        const role= localStorage.getItem('role');
      
        try{
          const roles= await getRoles(auth, role);
      
          roles.map((role)=>{
      
            const values= Object.values(role);
      
            values[0].map((val)=>{
      
              if(Object.keys(val).includes('fancy history')){
                const permit= Object.values(val);
      
                setPermit(permit[0]);
              }
            })
            
          })
        }catch(error){
          console.log('ert',error);
        }
      }
    
      useEffect(()=>{
        fetchRoles();
      },[]);

      useEffect(() => {
        const handleResize = () => {
          const mobile = window.innerWidth < 768;
          setIsMobile(mobile);
          
          // On desktop, sidebar should always be "open"
          if (!mobile) {
            setIsSidebarOpen(true);
          }
        };
        
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);

    return (
        <div className="wrapper">
  {/* Main Sidebar */}
  <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
    <div className="container-fluid">
      <h5 className="m-0">Fancy History</h5>
    </div>
    <section className="content">
      <div className="table-responsive">
        <table role="grid" className="table table-hover datatable table-striped mt-4">
          <thead className="bg-dark">
            <tr>
              <th>Match Name</th>
              <th>Name</th>
              <th>Result</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div>Cricket | International Twenty20 Matches</div>
                <div className="text-bold">Ireland v Pakistan</div>
              </td>
              <td>
                <div className="text-bold">Book Maker</div>
                <div>May 14 2024 07:30:00 PM</div>
              </td>
              <td />
              <td className='d-flex gap-2'>
                  <button className={`btn btn-sm btn-danger ${permit.includes('RollBack')? 'd-block':'d-none'}`}>
                    RollBack
                  </button>
                  <button className={`btn btn-sm btn-primary ${permit.includes('Position')? 'd-block':'d-none'}`}>
                    Position
                  </button>
              </td>
            </tr>
            
          </tbody>
        </table>
      </div>
    </section>
  </div>
  <a id="back-to-tops" href="##" className="btn btn-primary back-to-top" role="button" aria-label="Scroll to top">
    <i className="fas fa-chevron-up" />
  </a>
</div>

    )
}

export default FancyHistory